namespace $.$$ {
	export class $shm_mentionstat_chart extends $.$shm_mentionstat_chart {
		group_options() {
			return {
				day: 'По дням',
				week: 'По неделям',
				month: 'По месяцам',
				year: 'По годам',
			}
		}

		group_period_kind() {
			if( this.group() === 'week' ) return 'PERIOD_WEEKLY'
			if( this.group() === 'month' || this.group() === 'year' ) return 'PERIOD_MONTHLY'
			return 'PERIOD_DAILY'
		}

		date_title( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			if( !match ) return date
			if( this.group() === 'year' ) return match[1]
			if( this.group() === 'month' ) return `${ match[1] }-${ match[2] }`
			if( this.group() === 'week' ) {
				const interval = this.date_interval( date )
				return `${ this.date_title_day( interval.from ) }\n- ${ this.date_title_day( interval.to ) }`
			}
			return this.date_title_day( date )
		}

		date_interval( date: string ) {
			const from = String( date ).slice( 0, 10 )
			if( this.group() === 'year' ) return { from: `${ from.slice( 0, 4 ) }-01-01`, to: `${ from.slice( 0, 4 ) }-12-31` }
			if( this.group() === 'month' ) return {
				from,
				to: this.date_shift( from, value => {
					value.setUTCMonth( value.getUTCMonth() + 1 )
					value.setUTCDate( 0 )
				} ),
			}
			if( this.group() === 'week' ) return {
				from,
				to: this.date_shift( from, value => value.setUTCDate( value.getUTCDate() + 6 ) ),
			}
			return { from, to: from }
		}

		date_title_day( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : date
		}

		date_shift( date: string, shift: ( value: Date )=> void ) {
			const value = new Date( `${ date.slice( 0, 10 ) }T00:00:00Z` )
			if( Number.isNaN( value.getTime() ) ) return date
			shift( value )
			return value.toISOString().slice( 0, 10 )
		}
	}
}
